import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ArchivierteDatenabfrageListComponent } from './archivierte-datenabfrage-list/archivierte-datenabfrage-list.component';
import { MaterialModule } from '../common/material/material.module';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../common/formvalidation/global-directives.module';
import { ServiceModule } from '../service/service.module';
import { DatenabfrageCreateComponent } from './datenabfrage-create/datenabfrage-create.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AufteilungsschluesselEintragenComponent } from './netzbetreiber/aufteilungsschluessel-eintragen/aufteilungsschluessel-eintragen.component';
import { DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective } from '../erzeugungsanlage/directives/datenabfrage-abregelbare-leistung-lower-equals-installierte-validator.directive';
import { ResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective } from '../erzeugungsanlage/directives/reset-datenabfrage-abregelbare-leistung-error-when-installierte-changed-validator.directive';
import { DatenabfragePageComponent } from './datenabfrage-page/datenabfrage-page.component';
import { NetzbetreiberModule } from '../netzbetreiber/netzbetreiber.module';
import { NetzbetreiberDisplayCardComponent } from './netzbetreiber-display-card/netzbetreiber-display-card.component';
import { AufteilungsschluesselListComponent } from './aufteilungsschluessel-list/aufteilungsschluessel-list.component';
import { TeilnehmerAktiveDatenabfrageComponent } from './teilnehmer-aktive-datenabfrage/teilnehmer-aktive-datenabfrage.component';
import { AktiveDatenabfrageComponent } from './datenabfrage-aktive-component/aktive-datenabfrage.component';
import { DatenabfrageCardContentComponent } from './datenabfrage-card-content/datenabfrage-card-content.component';

@NgModule({
    declarations: [
        ArchivierteDatenabfrageListComponent,
        DatenabfrageCreateComponent,
        AufteilungsschluesselEintragenComponent,
        DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective,
        ResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective,
        AktiveDatenabfrageComponent,
        DatenabfragePageComponent,
        NetzbetreiberDisplayCardComponent,
        AufteilungsschluesselListComponent,
        TeilnehmerAktiveDatenabfrageComponent,
        DatenabfrageCardContentComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalDirectivesModule,
        ServiceModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NetzbetreiberModule,
        NgOptimizedImage,
    ],
})
export class DatenabfrageModule {
}
